import React, { useEffect, useState } from "react";
import axios from "axios";
import { CalendarCheck, Mail } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const TodayBlock = ({ headers, onWrite, refreshKey }) => {
  const [d, setD] = useState(null);
  useEffect(() => {
    axios.get(`${API}/admin/prospects/today`, { headers: headers() }).then(({ data }) => setD(data)).catch(() => {});
  }, [refreshKey]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!d) return null;
  const list = [...d.followups.map((p) => ({ ...p, _f: true })), ...d.items];
  const done = d.items.filter((p) => p.status !== "prêt à contacter").length;
  return (
    <section data-testid="prospects-today" className="mt-6 rounded-2xl border-2 border-[var(--oz-gold)] bg-white p-5">
      <div className="flex flex-wrap items-center gap-3">
        <CalendarCheck className="w-5 h-5 text-[var(--oz-gold)]" />
        <h2 className="font-semibold">À écrire aujourd'hui</h2>
        <span data-testid="prospects-today-progress" className="ml-auto text-sm text-[var(--oz-muted)]">{done} / {d.items.length} fait(s){d.followups.length ? ` · ${d.followups.length} relance(s) due(s)` : ""}</span>
      </div>
      <ul className="mt-4 grid sm:grid-cols-2 lg:grid-cols-3 gap-2">
        {list.map((p) => {
          const sent = !p._f && p.status !== "prêt à contacter";
          return (
            <li key={`${p.id}${p._f ? "f" : ""}`} data-testid={`today-item-${p.id}`} className={`flex items-center gap-3 rounded-xl border border-[var(--oz-border)] p-3 ${sent ? "opacity-50" : ""}`}>
              <div className="min-w-0 flex-1">
                <p className="text-sm font-semibold truncate">{p.name}</p>
                <p className="text-xs text-[var(--oz-muted)] truncate">{p._f ? "Relance · " : ""}{p.city} · {p.country || "France"}</p>
              </div>
              <button onClick={() => onWrite(p)} disabled={sent} data-testid={`today-write-${p.id}`}
                className="shrink-0 inline-flex items-center gap-1 rounded-full bg-[var(--oz-dark)] text-white text-xs font-semibold px-3 py-1.5 disabled:opacity-40">
                <Mail className="w-3.5 h-3.5 text-[var(--oz-gold)]" /> {sent ? "Fait" : p._f ? "Relancer" : "Écrire"}
              </button>
            </li>
          );
        })}
      </ul>
    </section>
  );
};
